import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Platform', 'Applications', 'Company', 'Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-line py-3' : 'bg-white border-b border-line py-4'}`} data-id="element-244">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-245">
        <div className="flex justify-between items-center" data-id="element-246">
          {/* Logo Area */}
          <div className="flex items-baseline gap-3" data-id="element-247">
            <a href="#" className="text-2xl font-heading font-bold text-navy tracking-tight" data-id="element-248">
              SyNeural
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-249">
            <ul className="flex items-center gap-6" data-id="element-250">
              {navItems.map(item => <li key={item} data-id="element-251">
                  <a href={`#${item.toLowerCase()}`} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors" data-id="element-252">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="w-px h-5 bg-line" data-id="element-253"></div>
            <button className="bg-navy hover:bg-navy-light text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm" data-id="element-254">
              Request Demo
            </button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-ink-dark p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-255">
            {mobileMenuOpen ? <X size={24} data-id="element-256" /> : <Menu size={24} data-id="element-257" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-258">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-line overflow-hidden" data-id="element-259">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-260">
              {navItems.map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-261">
                  {item}
                </a>)}
              <div className="pt-4 px-3" data-id="element-262">
                <button className="w-full bg-navy text-white font-medium px-5 py-3 rounded-md shadow-sm" data-id="element-263">
                  Request Demo
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}